import {
  PROFILE_EDIT_ROUTE,
  PROFILE_ROUTE,
  CALENDAR_ROUTE,
  PRO_CLIENT_LIST,
  PRO_IMAGE_LIST,
  PRO_PERSONAL_INFO_SETTINGS,
  PRO_BUSINESS_INFO_SETTINGS,
  PROVIDER_SETTINGS_FRONT_DESK,
  PRO_MANAGE_SERVICES,
} from '../../../../route-names';

export const PROVIDER_NAVIGATION = [
  {
    title: 'Calendar',
    link: CALENDAR_ROUTE,
  },
  {
    title: 'Clients',
    link: PRO_CLIENT_LIST,
  },
  {
    title: 'Growth',
    link: 'provider.growth_tab.summary',
  },
  {
    title: 'Marketing',
    link: 'provider.marketing_hub',
  },
  {
    title: 'Promotions',
    link: 'responsive.provider.promotions',
    shouldHide: responsive => !responsive?.wide,
  },
  {
    title: 'Profile',
    link: PROFILE_EDIT_ROUTE,
    subNav: [
      {
        title: 'Edit',
        link: PROFILE_EDIT_ROUTE,
      },
      {
        title: 'Preview',
        link: PROFILE_ROUTE,
      },
      {
        title: 'Promote',
        link: 'responsive.provider.promote',
      },
      {
        title: 'Personal Info',
        link: PRO_PERSONAL_INFO_SETTINGS,
      },
      {
        title: 'Business Info',
        link: PRO_BUSINESS_INFO_SETTINGS,
      },
      {
        title: 'Service Menu',
        link: PRO_MANAGE_SERVICES,
      },
      {
        title: 'Manage Availability',
        link: PROVIDER_SETTINGS_FRONT_DESK,
      },
      {
        title: 'Photos',
        link: PRO_IMAGE_LIST,
      },
      {
        title: 'Star Ratings & Reviews',
        link: 'responsive.provider.ratings_reviews',
      },
    ],
  },
  {
    title: 'More...',
    link: 'provider.settings_menu.more',
  },
];
